import {
    FeatureActionsList,
    FeaturesAndActions,
    FeaturesList
} from 'common/models/roles-and-access/roleAccess.model';

export const ROLES_AND_ACCESS_MOCK_DATA: FeaturesList = [
    {
        featureId: 'ecfa0059-3264-4207-9d1f-e53d6f3b16fc',
        featureKey: 'STATUS_TRACKING',
        subFeatures: []
    },
    {
        featureId: 'cf7e8e2e-b5b0-4da6-baa1-f52162c1d315',
        featureKey: 'ROLE_MANAGEMENT',
        subFeatures: []
    },
    {
        featureId: 'a3e511a2-543f-4fd2-abf8-4a77e46549d8',
        featureKey: 'ARCHIVE_FUNCTIONALITY_OF_MASTER_DATA',
        subFeatures: []
    },
    {
        featureId: '85980820-6d20-4e7f-9398-6b4479f3d168',
        featureKey: 'DATA_EDITOR_UPLOAD',
        subFeatures: []
    },
    {
        featureId: '7116950d-d3b3-4880-91ab-364351c47a44',
        featureKey: 'CONFIGURATION_GBB_PUBLIC',
        subFeatures: [
            {
                featureId: '9648d9a8-91ae-4074-ad99-fe8d4a52413d',
                featureKey: 'GEOGRAPHY_OVERVIEW',
                subFeatures: []
            },
            {
                featureId: 'f8690374-e57a-42c5-ae3a-53d6ea876cae',
                featureKey: 'FREQUENTLY_USED',
                subFeatures: []
            },
            {
                featureId: '6261f440-38e3-485f-917e-ba2fda1dcb6a',
                featureKey: 'VIDEO_LINK_(BRIGHTCOVE_VIDEO_LINK)',
                subFeatures: []
            },
            {
                featureId: 'dbb4e83a-a1a1-4439-a4c6-057b1c0c5690',
                featureKey: 'KEY_INDICATOR',
                subFeatures: []
            },
            {
                featureId: '948d645f-9de0-4de0-b63f-0143e03108fb',
                featureKey: 'TRENDING_DATA',
                subFeatures: []
            },
            {
                featureId: '34b77295-5f26-4c48-a319-2b693c88770d',
                featureKey: 'STATIC_INDICATOR',
                subFeatures: []
            },
            {
                featureId: '0eab9718-2ae9-43c2-bc38-c43c8fcde125',
                featureKey: 'WHATSNEW',
                subFeatures: []
            }
        ]
    },
    {
        featureId: '6af7a1c9-5629-44ad-81cb-a78f28583c91',
        featureKey: 'DATA_MANAGEMENT',
        subFeatures: [
            {
                featureId: '7521377c-81d2-4c72-a217-4361b2df9128',
                featureKey: 'EY_COMPANY_FOOTPRINT',
                subFeatures: []
            },
            {
                featureId: '11494c95-9d46-4b8f-8e83-ce5a8b620dcf',
                featureKey: 'INDICATOR_SOURCES',
                subFeatures: []
            }
        ]
    },
    {
        featureId: '494f1771-d8a7-4288-a7e0-36b6f64af769',
        featureKey: 'VARIANTS',
        subFeatures: [
            {
                featureId: '2469deb3-9541-48a4-97a1-1da2e9cf8ac1',
                featureKey: 'MASTER_DATA_MANAGEMENT',
                subFeatures: []
            }
        ]
    },
    {
        featureId: 'd52c3b96-a498-41f2-8fa9-ae79d2b9f4da',
        featureKey: 'GBB_VR_SESSIONS',
        subFeatures: []
    },
    {
        featureId: '',
        featureKey: 'USER_PERMISSION',
        subFeatures: []
    }
];

export const actionsMockData: FeatureActionsList = [
    {
        featureId: 'cf98f16f-3ce4-4735-860c-f9ead35b8d63',
        featureKey: 'DELETE_CATEGORY',
        read: true,
        write: true
    },
    {
        featureId: 'cf8653c4-9013-42aa-9328-002e911fe5a6',
        featureKey: 'EDIT_CATEGORY',
        read: true,
        write: true
    },
    {
        featureId: 'fa0a03dd-d17c-4dcf-bb0a-efb6bf721240',
        featureKey: 'ARCHIVE_CATEGORY',
        read: true,
        write: true
    },
    {
        featureId: 'b6bfba50-cffc-4820-b0ff-733f56bc97f5',
        featureKey: 'DELETE_INDICATOR',
        read: true,
        write: true
    },
    {
        featureId: '11158c25-378c-4e16-a516-11beb3d6c6b4',
        featureKey: 'SET_UP_FREQUENTLY_USED',
        read: true,
        write: true
    },
    {
        featureId: 'e78043b2-e442-42e9-99ef-32d358c201da',
        featureKey: 'ARCHIVE_SUB_CATEGORY',
        read: true,
        write: true
    },
    {
        featureId: 'd293fd2d-e29d-4812-acef-2ae4eab7ed84',
        featureKey: 'SYNC_HISTORY',
        read: true,
        write: true
    },
    {
        featureId: 'd4c9ce24-bf35-41fc-aab0-022e2b29f037',
        featureKey: 'GBB_VR_SESSIONS (SELF)',
        read: true,
        write: true
    },
    {
        featureId: '11fb0628-01b7-42fc-a5d4-1a4ab7260b01',
        featureKey: 'GBB_VR_SESSIONS_(OTHERS)',
        read: true,
        write: true
    },
    {
        featureId: '694a0d24-c763-49d0-a1a7-6e5f80ce9324',
        featureKey: 'MAP_DATA_TO_MASTER_DATA',
        read: true,
        write: true
    },
    {
        featureId: '9833cde5-df9b-477a-95d0-058305b86b2b',
        featureKey: 'SET_UP_STATIC_INDICATOR',
        read: true,
        write: true
    },
    {
        featureId: '3076e2e9-3e33-4996-84c2-05c27eb436cf',
        featureKey: 'EXPORT_CATEGORY',
        read: true,
        write: true
    },
    {
        featureId: '475c39c0-3b5a-45f1-a6c3-4b510bdf9c75',
        featureKey: 'SET_UP_KEY_INDICATOR',
        read: true,
        write: true
    },
    {
        featureId: 'f552ef2e-b3e9-4c6e-9028-f968bb572ccb',
        featureKey: 'EXPORT_INDICATOR',
        read: true,
        write: true
    },
    {
        featureId: 'eb11dc04-aa01-4997-a95c-a74e23f97a39',
        featureKey: 'EDIT_SUB_CATEGORY',
        read: true,
        write: true
    },
    {
        featureId: 'bbce85e0-6f55-4ae4-a1ec-53562be95a6d',
        featureKey: 'DELETE_ARCHIVED_ITEMS',
        read: true,
        write: true
    },
    {
        featureId: '1aa71939-caff-4d7a-9dc0-9e09745e9dd1',
        featureKey: 'RESTORE_ARCHIVED_ITEMS',
        read: true,
        write: true
    },
    {
        featureId: '8e788af8-1660-44b4-a18d-da31cb0ad930',
        featureKey: 'UPLOAD_DATA',
        read: true,
        write: true
    },
    {
        featureId: 'e3d1c0e7-e538-4cbd-8de1-9dd073621bd7',
        featureKey: 'SET_UP_USER_PERMISSION',
        read: true,
        write: true
    },
    {
        featureId: '9b3f333f-a10d-47b4-8841-5a549a1f0dc3',
        featureKey: 'EXPORT_DATA_SET',
        read: true,
        write: true
    },
    {
        featureId: 'b18b54de-f638-45c0-a111-83317c87941c',
        featureKey: 'SET_UP_BRIGHTCOVE_VIDEO_LINK',
        read: true,
        write: true
    },
    {
        featureId: '76378b83-46fa-4867-a5c9-c30c3b90badc',
        featureKey: 'CLONE_CATEGORY',
        read: true,
        write: true
    },
    {
        featureId: '370b364e-6936-4ff9-a739-8bf5f7a9fd40',
        featureKey: 'USER_PERMISSION',
        read: true,
        write: true
    },
    {
        featureId: '19212593-89b9-4d3d-91c0-99302383fdf0',
        featureKey: 'ADD_SUB_CATEGORY',
        read: true,
        write: true
    },
    {
        featureId: 'fc9ec16c-413d-4181-a055-1cc3a7f1c3cc',
        featureKey: 'ADD_INDICATOR',
        read: true,
        write: true
    },
    {
        featureId: '080eecc0-9638-4461-9299-3b91268abb80',
        featureKey: 'SET_UP_WHATSNEW',
        read: true,
        write: true
    },
    {
        featureId: '227ceef1-a712-48c8-9aca-736f34d95e2c',
        featureKey: 'SET_UP_ROLES_FEATURES',
        read: true,
        write: true
    },
    {
        featureId: '57768147-a61b-44ba-8a6d-bfbd7603b89c',
        featureKey: 'MOVE_INDICATOR',
        read: true,
        write: true
    },
    {
        featureId: '6225112f-b00b-49e2-a59b-0bec9ad11c0e',
        featureKey: 'PREVIEW_DATA',
        read: true,
        write: true
    },
    {
        featureId: 'a684ca37-a118-40e3-812a-0ad48a918d2c',
        featureKey: 'EDIT_INDICATOR',
        read: true,
        write: true
    },
    {
        featureId: '5c82dc40-f939-479b-8cc3-84362326205f',
        featureKey: 'SET_UP/CHANGE_PRESENCE_(UPDATE)',
        read: true,
        write: true
    },
    {
        featureId: '9f3a53e0-b4ce-440e-9e17-9e659735e1aa',
        featureKey: 'CLONE_SUB_CATEGORY',
        read: true,
        write: true
    },
    {
        featureId: '61525b33-273a-47b6-b564-02ac934fe2b7',
        featureKey: 'MOVE_SUB_CATEGORY',
        read: true,
        write: true
    },
    {
        featureId: '58bae1e7-4a23-47ab-878c-77a35dac1ede',
        featureKey: 'SET_UP_INDICATOR_SOURCES',
        read: true,
        write: true
    },
    {
        featureId: 'a7cd7252-113d-4956-bfd1-0b3ed5b20465',
        featureKey: 'UPLOAD_HISTORY',
        read: true,
        write: true
    },
    {
        featureId: '55c2736d-f3ee-4d6d-ac50-c2e00877c70b',
        featureKey: 'ARCHIVE_INDICATOR',
        read: true,
        write: true
    },
    {
        featureId: '24edafd1-2a88-43df-a6e4-ffaaaa5debfe',
        featureKey: 'MAP_TO_GBBPUBLIC',
        read: true,
        write: true
    },
    {
        featureId: '891cc693-7d73-4ee9-afd0-5b94290f5ada',
        featureKey: 'ROLES',
        read: true,
        write: true
    },
    {
        featureId: '4ece7251-3ef0-4076-9772-7e582f37f611',
        featureKey: 'MASTER_DATA_SET',
        read: true,
        write: true
    },
    {
        featureId: '1e70f200-7836-4028-9e0c-7e0497063b12',
        featureKey: 'SET_UP_GEOGRAPHY_OVERVIEW',
        read: true,
        write: true
    },
    {
        featureId: 'db817f3f-e7a8-4cfd-b850-01d40b4bb90a',
        featureKey: 'DELETE_SUB_CATEGORY',
        read: true,
        write: true
    },
    {
        featureId: '26d72c5a-05f1-4fa2-a3e2-1639f96090b6',
        featureKey: 'EXPORT_SUB_CATEGORY',
        read: true,
        write: true
    },
    {
        featureId: 'dff16be8-5e23-47b3-9d91-1c775fd0f799',
        featureKey: 'ADD_CATEGORY',
        read: true,
        write: true
    },
    {
        featureId: 'c2ea75a5-4f17-41b7-9cad-2c5fd35234a8',
        featureKey: 'ARCHIVED_ITEMS',
        read: true,
        write: true
    },
    {
        featureId: 'ead2ffbb-ff3e-45ec-89de-cd5bf45bc217',
        featureKey: 'LINK_INDICATOR',
        read: true,
        write: true
    },
    {
        featureId: 'c4375bf2-c15f-4ee5-af15-dce1c654d9b4',
        featureKey: 'SET_UP_TRENDING DATA',
        read: true,
        write: true
    },
    {
        featureId: 'a56e6b2c-0f17-49d9-9d61-7df7e133c1d6',
        featureKey: 'COPY_INDICATOR',
        read: true,
        write: true
    }
];

export const featuresAndActionsMockData: FeaturesAndActions = {
    featuresHierarchy: ROLES_AND_ACCESS_MOCK_DATA,
    featuresActions: actionsMockData
};
